import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {
  
  constructor(
    private authService: AuthService,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    console.log('🛡️ Auth Guard constructed - Platform:', isPlatformBrowser(this.platformId) ? 'Browser' : 'Server');
  }

  canActivate(): boolean {
    console.log('🛡️ Auth Guard: canActivate() called');
    
    // If we're in SSR (server-side), always allow access
    // The real auth check will happen on the client side after hydration
    if (!isPlatformBrowser(this.platformId)) {
      console.log('🔄 SSR detected - allowing access (client-side auth check will happen later)');
      return true;
    }
    
    console.log('🛡️ Browser detected - checking authentication...');
    const isAuth = this.authService.isAuthenticated();
    const token = this.authService.getToken();
    const user = this.authService.getCurrentUser();
    
    console.log('🛡️ Auth Guard Results:', {
      isAuthenticated: isAuth,
      hasToken: !!token,
      hasUser: !!user,
      userEmail: user?.email || 'none'
    });
    
    if (isAuth) {
      console.log('✅ Auth Guard: Access granted');
      return true;
    }
    
    console.log('❌ Auth Guard: Access denied - redirecting to login');
    // Clear any invalid tokens and redirect to login
    this.authService.logout();
    return false;
  }

  canActivateChild(): boolean {
    return this.canActivate();
  }
}